import React, { lazy, Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HistoryIcon from '@mui/icons-material/History';
import AssignmentIcon from '@mui/icons-material/Assignment';
import InsightsIcon from '@mui/icons-material/Insights';
import PoolIcon from '@mui/icons-material/Pool';
import PlaceIcon from '@mui/icons-material/Place';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import ChatSessionNavigator from '@platform/core/src/components/chat/ChatSessionNavigator';
import { DomainObjectManager } from '@platform/core/src/components/domain';
import { 
  locationConfig, 
  equipmentConfig, 
  workoutPlanConfig, 
  workoutSessionConfig, 
  bioLogConfig,
  BioLogSidebarPanel // <--- Import the new wrapper component
} from '../domainConfig';

const ActivitySidebar = lazy(() => import('../../components/activities/ActivitySidebar'));
const EquipmentSidebar = lazy(() => import('../../components/equipment/EquipmentSidebar'));
const StatsSidebarPanel = lazy(() => import('../../components/stats/StatsSidebarPanel'));
const CalendarSidebarPanel = lazy(() => import('../../components/calendars/CalendarSidebarPanel'));

const LazySidebarWrapper = ({ Component }) => (
  <Suspense fallback={<Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}><CircularProgress size={20} /></Box>}>
    <Component />
  </Suspense>
);

export const leftSidebarSections = [
  {
    id: 'workoutSessions',
    title: 'Session History',
    icon: <DynamicFeedIcon />,
    infoContent: "Your interactive sessions. You can save, rename, and revisit saved sessions. Note: Only the most recent few sessions are saved and will not be saved long term unless you specifically save them.",
    component: ChatSessionNavigator,
    dashboardId: 'chat_sessions_dashboard',
  },
];

export const sidebarSections = [
  { type: 'header', title: 'My Gym' },
  {
    id: 'myCalendars',
    title: 'Calendar',
    icon: <CalendarMonthIcon />,
    component: () => <LazySidebarWrapper Component={CalendarSidebarPanel} />,
  },
  {
    id: 'workoutLogs',
    title: 'Logs',
    icon: <HistoryIcon />,
    component: () => <DomainObjectManager config={workoutSessionConfig} sectionTitle="Workout History" />,
  },
  {
    id: 'workoutPlans',
    title: 'Workouts',
    icon: <AssignmentIcon />,
    component: () => <DomainObjectManager config={workoutPlanConfig} sectionTitle="Workout Plans"/>,
  },
  {
    id: 'locations',
    title: 'Locations',
    icon: <PlaceIcon />,
    component: () => <DomainObjectManager config={locationConfig} sectionTitle="My Locations" />,
  },
  {
    id: 'statistics',
    title: 'Analytics',
    icon: <InsightsIcon />,
    component: () => <LazySidebarWrapper Component={StatsSidebarPanel} />,
  },
  // {
  //   id: 'bioLogs',
  //   title: 'Health & Bio Logs',
  //   icon: <MonitorWeightIcon />,
  //   // UPDATED: Use the new panel with filtering instead of the generic manager
  //   component: () => <BioLogSidebarPanel />, 
  // },
  { type: 'header', title: 'Catalog' },
  {
    id: 'activities',
    title: 'Activities',
    icon: <PoolIcon />,
    component: () => <LazySidebarWrapper Component={ActivitySidebar} />,
  },
  {
    id: 'equipment',
    title: 'Equipment',
    icon: <FitnessCenterIcon />,
    component: () => <LazySidebarWrapper Component={EquipmentSidebar} />,
  },
];